import _ from 'lodash';

import { RECEIVE_ARTICLES, ARTICLES_SUBTYPE, RECEIVE_PAGE } from '../actions';

export const ARTICLE_TYPE = {
  EXTERNAL: 'EXTERNAL',
  PAGE_PREVIEW: 'PAGE_PREVIEW',
  INTERNAL: 'INTERNAL',
};

const commonState = {
  pressReleases: {
    featured: [],
    archived: [],
    total: 0,
    totalPages: 0,
  },
  headlines: {
    featured: [],
    archived: [],
    total: 0,
    totalPages: 0,
  },
  mustRead: [],
};

/**
 * The initial state of the home affordability calculator reducer state.
 *
 */
function getInitialState() {
  return commonState;
}

function reduceArticle(article) {
  const { title, excerpt, link, date } = article;
  const imageSource = _.get(
    article,
    '_embedded.wp:featuredmedia[0].source_url',
    '//www.nerdwallet.com/cdn/press-pages/images/bg-mustread-2.jpg'
  );
  const author = _.get(article, '_embedded.author', [{ name: 'NerdWallet' }]);
  const type =
    _.get(article, 'nw_company_page_meta.press_release_type', 'internal') ===
    'external'
      ? ARTICLE_TYPE.EXTERNAL
      : ARTICLE_TYPE.INTERNAL;
  const articleURL =
    _.get(article, 'nw_company_page_meta.press_release_url', link) || link;
  const mediaSiteID = _.get(article, 'nw_media_site[0]', 0);
  let mediaSite;

  if (mediaSiteID) {
    mediaSite = _.filter(
      _.get(article, '_embedded.wp:term', [[{ id: mediaSiteID }]]),
      (term) => _.get(term, '[0].id', 0) === mediaSiteID
    );
    // this prevents an error if the mediaSite is undefined
    mediaSite = _.get(mediaSite, '0.0');
  }

  return {
    title: title.rendered,
    excerpt: excerpt.rendered,
    imageSource,
    link: articleURL,
    author,
    type,
    date,
    mediaSite,
  };
}

function reduceArticleArray(articles) {
  return _.map(articles, (article) => reduceArticle(article));
}

function reduceCompanyPages({ featured, archived }) {
  const reducedPages = {};

  if (featured) {
    reducedPages.featured = reduceArticleArray(featured.data);
  }

  if (archived) {
    _.assign(reducedPages, {
      archived: [reduceArticleArray(archived.data)],
      total: archived.headers['X-WP-Total'],
      totalPages: archived.headers['X-WP-TotalPages'],
    });
  }

  return reducedPages;
}

function reduceHeadlines(state, data) {
  _.assign(state.headlines, reduceCompanyPages(data));
}

function reducePressReleases(state, data) {
  _.assign(state.pressReleases, reduceCompanyPages(data));
}

function reduceMustRead(state, articles) {
  // eslint-disable-next-line no-param-reassign
  state.mustRead = reduceArticleArray(articles, false);
}

export default (state = getInitialState(), action = {}) => {
  _.assign(commonState, state);
  const { page, data } = action;
  const keyMap = {
    [ARTICLES_SUBTYPE.HEADLINES]: 'headlines',
    [ARTICLES_SUBTYPE.PRESS_RELEASES]: 'pressReleases',
  };

  if (_.isEmpty(state)) {
    return getInitialState();
  }

  switch (action.type) {
    case RECEIVE_ARTICLES:
      ({
        [ARTICLES_SUBTYPE.HEADLINES]: reduceHeadlines,
        [ARTICLES_SUBTYPE.PRESS_RELEASES]: reducePressReleases,
        [ARTICLES_SUBTYPE.MUST_READ]: reduceMustRead,
      }[action.subtype](commonState, action.data));

      break;

    case RECEIVE_PAGE:
      commonState[keyMap[action.subtype]].archived[page] = data;

      break;

    default:
    // do nothing
  }

  // Return the new state.
  return _.cloneDeep(commonState);
};
